/**
 * Define our route selectable stylesheets
 *
 * @type {Object}
 */
const stylesheets = {
  tw:
    "/css/BICAD.css?v=1.4",
  en:
    "/css/BICAD_en.css?v=1.4",
  backside:
    "/css/backSideStyle.css?v=1.3",
  custom:
    "/css/custom.css?v=1.3",
};

const adminsheet = [ 
  {
    id: "admin-bootstrap",
    href: "/css/vendor/bootstrap.css?v=1.1",
  },
  {
    id: "admin-bootstrap-vue",
    href: "/css/vendor/bootstrap-vue.css?v=1.1",
  },
  {
    id: "admin-sidebar-menu",
    href: "/css/vendor/vue-sidebar-menu.css?v=1.1",
  },
];

const cssElement = document.getElementById("stylesheet");
const loadingElement = document.getElementById("loading");
const uploadingElement = document.getElementById("uploading_cirtxt");

const langElement = document.getElementById("lang");

const descriptionElement = document.getElementById("description");
const keywordsElement = document.getElementById("keywords");
const copyrightElement = document.getElementById("copyright");

const ogTitleElement = document.getElementById("og_title");
const ogSiteNameElement = document.getElementById("og_site_name");
const ogUrlElement = document.getElementById("og_url");
const ogDescriptionElement = document.getElementById("og_description");

const indexNoScriptElement = document.getElementById("indexNoScript");

/**
 * Set the default fallback stylesheet
 * @type {[type]}
 */
const defaultStylesheet = stylesheets.tw;

export default function stylesheet(to, from, next) {
  const isAdmin = to.matched.some(
    record => record.meta.stylesheet === "backside"
  );
  toggleAdminStyles(isAdmin);

  if (to.meta.stylesheet !== from.meta.stylesheet) {
    cssElement.href = stylesheets[to.meta.stylesheet] || defaultStylesheet;
    if(to.meta.stylesheet=="tw") {
      setTimeout(function () {
        loadingElement.classList.add("dispnone");
        loadingElement.style.display = "none";
      }, 1000);
      
      langElement.setAttribute("lang", "zh-TW");
      uploadingElement.innerHTML = "處理中";
      descriptionElement.setAttribute("content", "國立臺灣大學生物產業傳播暨發展學系由農推轉型成培育農產業行銷傳播及農鄉社會永續發展專業人才，關注生農產業中之農業產銷、人類生活與社會-生態環境永續發展等多元面向，並強化在地產業鏈結，本系主辦「傳播學程」，其為一個跨院系所的特色學程，聯合文學院與社科院系所合作開設。");
      keywordsElement.setAttribute("content", "國立臺灣大學,臺灣大學,臺大,台大,生物產業傳播暨發展學系,生傳系,台大生傳系,臺大生傳系,國立臺灣大學生物產業傳播暨發展學系,生物,產業傳播,NTU,Department of Bio-Industry Communication and Development-Curriculum,bicd");
      copyrightElement.setAttribute("content", "國立臺灣大學");

      ogTitleElement.setAttribute("content", to.meta.og_title);
      ogSiteNameElement.setAttribute("content", to.meta.title);
      ogUrlElement.setAttribute("content", "https://www.bicd.ntu.edu.tw/");
      ogDescriptionElement.setAttribute("content", to.meta.og_description);
    } else if(to.meta.stylesheet=="en") {
      setTimeout(function () {
        loadingElement.classList.add("dispnone");
        loadingElement.style.display = "none";
      }, 1000);
      
      langElement.setAttribute("lang", "en-US");
      
      uploadingElement.innerHTML = "uploading";
      descriptionElement.setAttribute("content", "The Department of Bio-Industry Communication and Development at National Taiwan University has evolved from its origins in agricultural extension to become a program dedicated to cultivating professionals in agricultural marketing communication and the sustainable development of rural communities. The department focuses on diverse aspects of the bio-agricultural industry—including agricultural production and marketing, human well-being, and the sustainable development of socio-ecological environments—while strengthening linkages within local industry chains. Additionally, the department administers the 'Communication Program,' a distinctive interdisciplinary initiative offered in collaboration with departments across the College of Liberal Arts and the College of Social Sciences.");
      keywordsElement.setAttribute("content", "National Taiwan University, NTU, Department of Bio-Industry Communication and Development, BICD");
      copyrightElement.setAttribute("content", "National Taiwan University");

      ogTitleElement.setAttribute("content", to.meta.og_title);
      ogSiteNameElement.setAttribute("content", to.meta.title);
      ogUrlElement.setAttribute("content", "https://www.bicd.ntu.edu.tw/EN");
      ogDescriptionElement.setAttribute("content", to.meta.og_description);
    } else {
      loadingElement.classList.add("dispnone");
      loadingElement.style.display = "none";
    }
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }

  return next();
}

function toggleAdminStyles(enabled){
  adminsheet.forEach(({id,href}) => {
    const existing = document.getElementById(id);
    if(enabled){
      if(existing) return;
      const link = document.createElement("link");
      link.id=id;
      link.rel = "stylesheet";
      link.href = href;

      cssElement.parentNode.insertBefore(link,cssElement);
    } else if(existing){
      existing.remove();
    }
  });
}
